import { QueryFunction } from '@tanstack/react-query';
import {
  EncompassEfolderConfigurationResponse,
  EncompassEFolders,
} from 'src/types/configurations';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

const getEncompassEfolderConfiguration: QueryFunction<
  EncompassEFolders,
  ['/configurations/Encompass/Efolder']
> = async () => {
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<EncompassEfolderConfigurationResponse>(
    '/configurations/Encompass/Efolder',
    {
      method: 'GET',
    },
  );

  if (response.data) return response.data.configuration;
  throw new Error('Failed to fetch Encompass Efolder configuration');
};

export default getEncompassEfolderConfiguration;
